import {
  EmptyState,
  PageContentWrapper,
  PageHeader,
  PermissionIcon
} from '@lmc/ui-kit'
import { useAbilityAccess } from 'components/AccessControl'
import { NAMESPACE } from 'locale'
import { dacConstants } from 'locale/deviceAccessControl'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import DeviceSignsPanel from './DeviceSignsPanel'

const HELP_DISABLED =
  'https://support.logmycare.co.uk/en/articles/8010663-how-do-i-set-up-device-access-control'

const HELP_ENABLED =
  'https://support.logmycare.co.uk/en/articles/8010671-how-do-i-manage-devices-in-my-care-home'

export const DeviceSignsScreen: FC = () => {
  const navigate = useNavigate()

  const { t } = useTranslation(NAMESPACE.DEVICE_ACCESS_CONTROL)

  const hasRolePermission = useAbilityAccess([
    { i: 'update', this: 'MobileDevice' }
  ])

  if (!hasRolePermission) {
    return (
      <PageContentWrapper
        $gap={0}
        $paddingTop={24}
        $paddingX={24}
        $paddingBottom={24}
      >
        <PageHeader
          title={t(dacConstants.DEVICES)}
          moreInfoLink={HELP_DISABLED}
        />
        <EmptyState
          title={t(dacConstants.PSST)}
          description={t(dacConstants.NO_PERMISSIONS)}
          icon={<PermissionIcon />}
        />
      </PageContentWrapper>
    )
  }

  return (
    <PageContentWrapper
      $gap={0}
      $paddingTop={24}
      $paddingX={24}
      $paddingBottom={24}
      data-testid="device-signs-screen"
    >
      <PageHeader
        title={t(dacConstants.DEVICE_SIGN_INS)}
        onBack={() => navigate(-1)}
        moreInfoLink={HELP_ENABLED}
        testId="device-signs-header"
      />
      <ContentWrapper data-testid="device-signs-content">
        <DeviceSignsPanel
          hasRolePermission={hasRolePermission}
          syncUrl
          testId="device-signs-panel"
        />
      </ContentWrapper>
    </PageContentWrapper>
  )
}

const ContentWrapper = styled.div`
  margin-top: 24px;
`

export default DeviceSignsScreen
